/**
 * Extends the String prototype with additional utility methods
 */

// Extend String prototype with abbreviate method
if (!String.prototype.abbreviate) {
  String.prototype.abbreviate = function (maxLength: number): string {
    if (!this || this.length <= maxLength) {
      return this;
    }
    return this.substring(0, maxLength) + '...';
  };
}
